export default __webpack_public_path__ + "static/media/announcement.d7f30ecb.jpg";